// wgn-combined-reviews.js
(function() {
  function escapeHTML(str) {
    if (!str) return '';
    return str.replace(/[&<>'"]/g, 
      tag => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[tag] || tag));
  }

  function hasRealAmazonReviewContent(text) {
    if (!text) return false;
    const t = text.toLowerCase();
    if (/no reviews|no customer reviews|be the first/i.test(t)) return false;
    return (
      /\d+(\.\d+)?\s*out\s*of\s*5/i.test(t) ||
      /[\d,]+\s*(global\s*)?(ratings?|reviews?)/i.test(t) ||
      /customers\s+say/i.test(t)
    );
  }

  function initCombinedReviews() {
    const sections = document.querySelectorAll('.wgn-combined-reviews');
    sections.forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';

      const configEl = document.getElementById('wgn-combined-reviews-config-' + section.dataset.sectionId);
      if (!configEl) return;
      let config = {};
      try {
        config = JSON.parse(configEl.textContent);
      } catch(e) {
        console.error('WGN Combined Reviews: Invalid config', e);
        return;
      }

      const tabs = section.querySelectorAll('.wgn-combined-reviews__tab');
      const panels = {
        all: section.querySelector('#wgn-tab-all-' + section.dataset.sectionId),
        store: section.querySelector('#wgn-tab-store-' + section.dataset.sectionId),
        amazon: section.querySelector('#wgn-tab-amazon-' + section.dataset.sectionId)
      };

      const tabBtns = {
        all: section.querySelector('#wgn-tab-btn-all-' + section.dataset.sectionId),
        store: section.querySelector('#wgn-tab-btn-store-' + section.dataset.sectionId),
        amazon: section.querySelector('#wgn-tab-btn-amazon-' + section.dataset.sectionId)
      };

      // Tab logic
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => {
            t.setAttribute('aria-selected', 'false');
            t.classList.remove('wgn-combined-reviews__tab--active');
          });
          Object.values(panels).forEach(p => {
            if(p) {
              p.hidden = true;
              p.classList.remove('wgn-combined-reviews__panel--active');
            }
          });

          tab.setAttribute('aria-selected', 'true');
          tab.classList.add('wgn-combined-reviews__tab--active');
          const targetId = tab.getAttribute('aria-controls');
          const targetPanel = section.querySelector('#' + targetId);
          if (targetPanel) {
            targetPanel.hidden = false;
            targetPanel.classList.add('wgn-combined-reviews__panel--active');
          }
        });
      });

      const state = {
        okendo: { status: 'pending', reviews: [] },
        amazon: { status: 'pending', reviews: [], widgetFound: false, summary: null },
        initialRenderDone: false
      };

      let extractionTimeout = null;
      let observer = null;
      let observerThrottler = null;
      const MAX_TIMEOUT_MS = (config.loadTimeout || 8) * 1000;
      const seenReviews = new Set();
      const seenAmznReviews = new Set();

      function okendoIsAvailable() {
        return config.showOkendo && state.okendo.status === 'ready' && state.okendo.reviews.length > 0;
      }

      function amazonIsAvailable() {
        return config.showAmazon && (state.amazon.status === 'ready' || state.amazon.status === 'widget_only');
      }

      function escapeText(str) {
        return escapeHTML(str ? str.trim() : '');
      }

      function renderStars(rating) {
        let starsHtml = '';
        for (let i = 0; i < 5; i++) {
          if (i < rating) {
            starsHtml += config.starIcon;
          } else {
            starsHtml += `<span style="opacity: 0.3">${config.starIcon}</span>`;
          }
        }
        return starsHtml;
      }

      function buildCardHtml(review) {
        if (review.isAmazonCTA) {
          let sourceLogoHtml = config.amazonLogoSource === 'inline_svg' && config.amazonLogoSvg ? config.amazonLogoSvg : '<span>Amazon</span>';
          return `
            <div class="wgn-review-card wgn-review-card--${escapeHTML(config.cardStyle)}" style="justify-content: center; align-items: center; text-align: center;">
              <div class="wgn-review-card__source wgn-review-card__source--amazon" style="justify-content: center; width: 100%; margin-bottom: 16px; height: 32px;">
                ${sourceLogoHtml}
              </div>
              <div class="wgn-review-card__body" style="flex-grow: 0;">
                <div class="wgn-review-card__title">More Reviews Available</div>
                <div>Read our verified customer reviews from Amazon.</div>
              </div>
              <button style="margin-top: 16px; padding: 10px 20px; font-size: 14px; font-weight: 600; border-radius: 24px; background: #000; color: #fff; border: none; cursor: pointer; transition: background 0.2s;" onmouseover="this.style.background='#333'" onmouseout="this.style.background='#000'" onclick="document.querySelector('#wgn-tab-btn-amazon-${escapeHTML(section.dataset.sectionId)}').click()">View Amazon Reviews</button>
            </div>
          `;
        }

        let sourceLogoHtml = '';
        if (config.showSourceLogo) {
          if (review.source === 'okendo') {
            const defaultOkendoLogo = 'https://okendo.io/wp-content/themes/okendo/components/header/assets/logo.svg';
            const logoUrl = config.okendoLogoUrl || defaultOkendoLogo;
            sourceLogoHtml = `<img src="${escapeHTML(logoUrl)}" alt="Okendo" style="height:20px; width:auto;">`;
          } else if (review.source === 'amazon') {
            sourceLogoHtml = `<div class="wgn-review-card__source--amazon">${config.amazonLogoSource === 'inline_svg' && config.amazonLogoSvg ? config.amazonLogoSvg : '<span>Amazon</span>'}</div>`;
          }
        }

        let avatarHtml = '';
        if (config.showReviewerAvatar) {
          const initial = review.reviewerName ? review.reviewerName.charAt(0).toUpperCase() : 'A';
          avatarHtml = `
            <div class="wgn-review-card__avatar">
              ${escapeHTML(initial)}
            </div>
          `;
        }

        let productNameHtml = '';
        if (config.showProductName && review.productName) {
          productNameHtml = `<div style="font-size: 12px; color: #5f7482; margin-bottom: 8px;">${escapeHTML(review.productName)}</div>`;
        }

        return `
          <div class="wgn-review-card wgn-review-card--${escapeHTML(config.cardStyle)}">
            <div class="wgn-review-card__top">
              <div class="wgn-review-card__stars-time">
                <div class="wgn-review-card__stars">${renderStars(review.rating)}</div>
                ${config.showReviewDate ? `<div class="wgn-review-card__time">${escapeHTML(review.date)}</div>` : ''}
              </div>
              <div class="wgn-review-card__source">${sourceLogoHtml}</div>
            </div>
            ${productNameHtml}
            <div class="wgn-review-card__body">
              ${review.title ? `<div class="wgn-review-card__title">${escapeHTML(review.title)}</div>` : ''}
              <div>${escapeHTML(review.body)}</div>
            </div>
            <div class="wgn-review-card__reviewer">
              ${avatarHtml}
              <div class="wgn-review-card__reviewer-info">
                <span class="wgn-review-card__reviewer-name">${escapeHTML(review.reviewerName) || 'Anonymous'}</span>
                ${review.verified ? `<span class="wgn-review-card__reviewer-verified">Verified Buyer</span>` : ''}
              </div>
            </div>
          </div>
        `;
      }

      function populateMarquee(panel, reviews) {
        if (!panel) return;
        const tracks = panel.querySelectorAll('.wgn-combined-reviews__track');
        const emptyMsg = panel.querySelector('.wgn-combined-reviews__empty');
        const marquees = panel.querySelectorAll('.wgn-combined-reviews__marquee');

        if (reviews.length === 0) {
          marquees.forEach(m => m.style.display = 'none');
          if (emptyMsg) emptyMsg.style.display = 'block';
          return;
        }

        if (emptyMsg) emptyMsg.style.display = 'none';
        marquees.forEach(m => m.style.display = 'flex');

        let html1 = '';
        let html2 = '';
        
        let displayReviews = [...reviews];
        while (displayReviews.length > 0 && displayReviews.length < 12) {
          displayReviews = displayReviews.concat(reviews);
        }
        displayReviews = displayReviews.slice(0, Math.max(config.maxReviews * 2, 20));

        const mid = Math.ceil(displayReviews.length / 2);
        const row1 = displayReviews.slice(0, mid);
        const row2 = displayReviews.slice(mid);

        const loop1 = [...row1, ...row1, ...row1];
        const loop2 = [...row2, ...row2, ...row2];

        loop1.forEach(r => html1 += buildCardHtml(r));
        loop2.forEach(r => html2 += buildCardHtml(r));

        if (tracks[0]) {
          tracks[0].innerHTML = html1;
          tracks[0].style.setProperty('--marquee-speed', config.autoplaySpeed + 's');
        }
        if (tracks[1]) {
          tracks[1].innerHTML = html2;
          tracks[1].style.setProperty('--marquee-speed', config.autoplaySpeed + 's');
        }
      }

      function extractOkendo() {
        if (state.okendo.status === 'ready' || !config.showOkendo) return;

        let root = section.querySelector('.wgn-combined-reviews__okendo-source');
        if (config.usePageOkendoSource && (!root || root.querySelectorAll('.okeReviews-reviewsCarousel-review').length === 0)) {
           root = document;
        }

        if (!root) return;

        const oReviews = root.querySelectorAll('.okeReviews-reviewsCarousel-review');
        if (oReviews.length > 0) {
          oReviews.forEach(el => {
            const titleEl = el.querySelector('.okeReviews-reviewsCarousel-review-content-heading');
            const bodyEl = el.querySelector('.okeReviews-reviewsCarousel-review-content-body');
            const nameEl = el.querySelector('.okeReviews-reviewsCarousel-review-reviewer-name');
            const dateEl = el.querySelector('.okeReviews-reviewsCarousel-review-reviewer-date');
            
            const title = escapeText(titleEl ? titleEl.textContent : '');
            const body = escapeText(bodyEl ? bodyEl.textContent : '');
            const reviewerName = escapeText(nameEl ? nameEl.textContent : '');
            const date = escapeText(dateEl ? dateEl.textContent : '');
            
            const key = title + body + reviewerName + date;
            if (seenReviews.has(key)) return;
            seenReviews.add(key);
            
            let rating = 5;
            const ratingContainer = el.querySelector('.okeReviews-reviewsCarousel-review-content-rating');
            if (ratingContainer) {
              const a11yText = ratingContainer.querySelector('.okeReviews-a11yText');
              if (a11yText) {
                const match = a11yText.textContent.match(/Rated\s*(\d+(\.\d+)?)\s*out\s*of/i);
                if (match) rating = parseFloat(match[1]);
              }
            }

            state.okendo.reviews.push({
              source: 'okendo', title, body, reviewerName, date, rating, verified: true
            });
          });
        }

        if (state.okendo.reviews.length > 0) {
           state.okendo.status = 'ready';
        }
      }

      function extractAmazon() {
        if (state.amazon.status === 'ready' || state.amazon.status === 'widget_only' || state.amazon.status === 'empty' || !config.showAmazon) return;

        const widgetCandidates = [
           ...section.querySelectorAll('.wgn-combined-reviews__amazon-stage amazon-product-reviews'),
           ...section.querySelectorAll('.wgn-combined-reviews__amazon-stage #amzn-roa-reviews'),
           ...section.querySelectorAll('.wgn-combined-reviews__amazon-official-wrapper amazon-product-reviews'),
           ...section.querySelectorAll('.wgn-combined-reviews__amazon-official-wrapper #amzn-roa-reviews'),
           ...(config.renderAmazonWidget ? [] : document.querySelectorAll('amazon-product-reviews')),
           ...(config.renderAmazonWidget ? [] : document.querySelectorAll('#amzn-roa-reviews'))
        ];

        let widget = null;
        for (const cand of widgetCandidates) {
           if (cand && cand.id !== 'amzn-buy-now') {
              widget = cand;
              break;
           }
        }

        if (!widget) return;
        
        state.amazon.widgetFound = true;

        const roots = [widget];
        if (widget.shadowRoot) roots.push(widget.shadowRoot);
        const templates = widget.querySelectorAll('template');
        templates.forEach(t => roots.push(t.content));

        let foundRealContent = false;

        roots.forEach(root => {
           if (!root) return;

           const rawText = root.textContent || '';
           if (hasRealAmazonReviewContent(rawText)) {
              foundRealContent = true;
           }

           if (!state.amazon.summary) {
              const ratingEl = root.querySelector('[data-testid="star-rating"], .product-summary');
              const countEl = root.querySelector('[data-testid="rating-count-container"]');
              const ratingText = ratingEl ? ratingEl.textContent : root.textContent;
              const countText = countEl ? countEl.textContent : root.textContent;

              let rating = null;
              let count = null;
              
              const rm = ratingText.match(/([\d\.]+)\s*out\s*of\s*5/i);
              if (rm) rating = parseFloat(rm[1]);

              const cm = countText.match(/([\d,]+)\s*(global\s*ratings?|ratings?|reviews?)/i);
              if (cm) count = parseInt(cm[1].replace(/,/g, ''), 10);

              if (rating && count) {
                 state.amazon.summary = { rating, count };
                 foundRealContent = true;
              }
           }

           const reviewNodes = root.querySelectorAll('.modal-reviews, [data-testid="customer-review"], .review-card, .a-section.review');
           reviewNodes.forEach(node => {
              const titleNode = node.querySelector('[data-hook="review-title"], .review-title');
              const bodyNode = node.querySelector('[data-hook="review-body"], .review-text');
              const nameNode = node.querySelector('.a-profile-name, .reviewer-name');
              
              const title = titleNode ? escapeText(titleNode.textContent) : 'Amazon Customer Review';
              const body = bodyNode ? escapeText(bodyNode.textContent) : escapeText(node.textContent);
              const name = nameNode ? escapeText(nameNode.textContent) : 'Amazon Customer';

              const key = title + body + name;
              if (seenAmznReviews.has(key)) return;
              if (body.trim().length < 5) return;
              seenAmznReviews.add(key);

              state.amazon.reviews.push({
                 source: 'amazon',
                 title,
                 body,
                 reviewerName: name,
                 date: '',
                 rating: state.amazon.summary ? state.amazon.summary.rating : 5,
                 verified: false
              });
              foundRealContent = true;
           });

           if (state.amazon.reviews.length === 0) {
              const insights = root.querySelector('.product-insights-container, [data-testid="customers-say"]');
              if (insights) {
                 const text = escapeText(insights.textContent);
                 if (text.length > 20 && hasRealAmazonReviewContent(text)) {
                    const key = 'insights' + text;
                    if (!seenAmznReviews.has(key)) {
                       seenAmznReviews.add(key);
                       state.amazon.reviews.push({
                          source: 'amazon',
                          title: 'Customers Say',
                          body: text,
                          reviewerName: 'Amazon Summary',
                          date: '',
                          rating: state.amazon.summary ? state.amazon.summary.rating : 5,
                          verified: false
                       });
                       foundRealContent = true;
                    }
                 }
              }
           }
        });

        if (state.amazon.reviews.length > 0) {
           state.amazon.status = 'ready';
        } else if (foundRealContent) {
           state.amazon.status = 'widget_only';
        } else if (widget.tagName === 'AMAZON-PRODUCT-REVIEWS' && widget.offsetHeight > 50) {
           // Closed shadow DOM on live domain successfully hydrated and rendered content
           state.amazon.status = 'widget_only';
        } else if (widget.innerHTML.length > 10 || widget.shadowRoot) {
           if (hasRealAmazonReviewContent(widget.textContent || '')) {
              state.amazon.status = 'widget_only';
           }
        }
      }

      function moveAmazonWidgetIfNeeded() {
        const amznWrapper = section.querySelector('.wgn-combined-reviews__amazon-official-wrapper');
        if (!amznWrapper) return;

        const candidates = config.renderAmazonWidget
          ? [
              section.querySelector('.wgn-combined-reviews__amazon-stage amazon-product-reviews'),
              section.querySelector('.wgn-combined-reviews__amazon-stage #amzn-roa-reviews'),
              amznWrapper.querySelector('amazon-product-reviews'),
              amznWrapper.querySelector('#amzn-roa-reviews')
            ]
          : [
              document.querySelector('amazon-product-reviews'),
              document.querySelector('#amzn-roa-reviews')
            ];

        let existingAmzn = null;
        for (const cand of candidates) {
           if (cand && cand.id !== 'amzn-buy-now') {
              existingAmzn = cand;
              break;
           }
        }

        if (existingAmzn && !amznWrapper.contains(existingAmzn)) {
           amznWrapper.appendChild(existingAmzn);
        }
      }

      function updateUIState() {
        section.classList.remove('wgn-combined-reviews--loading');
        section.classList.add('wgn-combined-reviews--ready');

        const okendoAvailable = okendoIsAvailable();
        const amazonAvailable = amazonIsAvailable();
        const okendoEmpty = !okendoAvailable;
        const amazonEmpty = !amazonAvailable;

        if (amazonAvailable) {
          moveAmazonWidgetIfNeeded();
        }

        if (amazonEmpty && tabBtns.amazon) tabBtns.amazon.hidden = true;
        else if (!amazonEmpty && tabBtns.amazon) tabBtns.amazon.hidden = false;

        if (okendoEmpty && tabBtns.store) tabBtns.store.hidden = true;
        else if (!okendoEmpty && tabBtns.store) tabBtns.store.hidden = false;

        // Recalculate default tab if current is hidden
        const activeTabBtn = section.querySelector('.wgn-combined-reviews__tab--active');
        if (!activeTabBtn || activeTabBtn.hidden) {
           if (tabBtns.all && !tabBtns.all.hidden) tabBtns.all.click();
           else if (tabBtns.store && !tabBtns.store.hidden) tabBtns.store.click();
           else if (tabBtns.amazon && !tabBtns.amazon.hidden) tabBtns.amazon.click();
        }

        let allReviews = [...(okendoAvailable ? state.okendo.reviews : []), ...state.amazon.reviews];

        if (amazonAvailable && state.amazon.status === 'widget_only' && state.amazon.reviews.length === 0) {
           allReviews.push({ isAmazonCTA: true });
        }

        if (panels.store) populateMarquee(panels.store, okendoAvailable ? state.okendo.reviews : []);
        if (panels.all) populateMarquee(panels.all, allReviews);
        
        if (panels.amazon) {
          populateMarquee(panels.amazon, state.amazon.status === 'ready' ? state.amazon.reviews : []);
          const amazonWrapper = panels.amazon.querySelector('.wgn-combined-reviews__amazon-official-wrapper');
          if (amazonWrapper) {
            amazonWrapper.style.display = state.amazon.status === 'widget_only' ? '' : 'none';
          }
          if (amazonWrapper && amazonAvailable) {
            const emptyMsg = panels.amazon.querySelector('.wgn-combined-reviews__empty');
            if(emptyMsg) emptyMsg.style.display = 'none';
          }
        }

        if (config.hideIfNoReviews && okendoEmpty && amazonEmpty) {
          section.style.display = 'none';
        }
      }

      function attemptExtraction() {
        if (config.showOkendo) extractOkendo();
        if (config.showAmazon) extractAmazon();

        const okendoDone = !config.showOkendo || (state.okendo.status === 'ready' || state.okendo.status === 'empty');
        const amazonDone = !config.showAmazon || (state.amazon.status === 'ready' || state.amazon.status === 'widget_only' || state.amazon.status === 'empty');
        const anySourceReady = okendoIsAvailable() || amazonIsAvailable();

        // Fast render when a real source is available. Other sources can populate silently later.
        if (anySourceReady && !state.initialRenderDone) {
           state.initialRenderDone = true;
           updateUIState();
        }

        if (okendoDone && amazonDone) {
           finalize();
        } else if (state.initialRenderDone && anySourceReady) {
           // Dynamic update if a late source arrives after the first render
           updateUIState();
        }
      }

      function finalize() {
        if (observer) observer.disconnect();
        if (extractionTimeout) clearTimeout(extractionTimeout);

        if (config.showAmazon && state.amazon.status === 'pending') {
           state.amazon.status = 'empty';
        }

        if (config.showOkendo && state.okendo.status === 'pending') {
           state.okendo.status = 'empty';
        }

        if (amazonIsAvailable()) {
          moveAmazonWidgetIfNeeded();
        }
        state.initialRenderDone = true;
        updateUIState();
      }

      observer = new MutationObserver(() => {
         if (observerThrottler) return;
         observerThrottler = setTimeout(() => {
            attemptExtraction();
            observerThrottler = null;
         }, 200);
      });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true });
      
      attemptExtraction();

      // Progressive extraction checks
      [500, 1500, 3000].forEach(delay => setTimeout(attemptExtraction, delay));

      extractionTimeout = setTimeout(() => {
         finalize();
      }, MAX_TIMEOUT_MS);

    });
  }

  document.addEventListener('DOMContentLoaded', initCombinedReviews);
  initCombinedReviews();

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('wgn-combined-reviews')) {
      initCombinedReviews();
    }
  });

})();
